export default "__VITE_ASSET__Bs8tk0n9__"